var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DqsHolder"},[_c('dqs',{staticClass:"DqsModule",attrs:{"calculated-dqs":_vm.totalScore,"stroke-dash-array":_vm.totalPossibleScore,"stroke-color":_vm.strokeColor,"is-visible":_vm.dqsIsVisible}}),_vm._v(" "),_c('span',{staticClass:"IconContainer"},[_c('tooltip',{attrs:{"tooltip-message":_vm.determinantScoresMessage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }